import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import isBoolean from 'lodash-es/isBoolean';
import { CollapseWrapper } from './styles';
import { getLabelId } from '../utils/aria';
import warning from '../utils/console-deprecated';
const Collapse = ({
  id,
  children,
  onChange,
  isOpen: isOpenProp,
  renderTrigger,
  ...props
}) => {
  const isControlled = isBoolean(isOpenProp);
  const collapseId = useMemo(() => id || getLabelId('urc-collapse'), [id]);
  const [isOpenState, setOpen] = useState(isOpenProp || false);
  useEffect(() => {
    if (!renderTrigger && !id) {
      warning('a11y: URC <Collapse> make sure you set proper attributes. see: https://www.w3.org/WAI/ARIA/apg/patterns/disclosure/');
    }
  }, [renderTrigger, id]);
  const toggleCollapse = () => {
    if (isControlled) {
      warning('Collapse / You are trying to change a controlled collapse component. Please a custom onClick function to control the collapsed state.');
    }
    const value = !isOpenState;
    setOpen(value);
    onChange?.(value);
  };
  const isOpen = isControlled ? isOpenProp : isOpenState;
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderTrigger ? renderTrigger({
    isOpen: isOpenState,
    onClick: toggleCollapse,
    'aria-expanded': isOpenState,
    'aria-controls': collapseId
  }) : null, /*#__PURE__*/React.createElement(CollapseWrapper, _extends({
    id: collapseId
  }, props, {
    $isOpen: isOpen
  }), /*#__PURE__*/React.createElement("div", {
    "aria-hidden": !isOpen,
    inert:
    // value as string because [inert] is not supported on React 18
    // TODO: update to a real boolean when updating to React 19
    isOpen ? undefined : 'true'
  }, children)));
};
Collapse.propTypes = {
  isOpen: PropTypes.bool,
  onChange: PropTypes.func,
  children: PropTypes.node.isRequired
};
export default Collapse;
//# sourceMappingURL=index.js.map